module.exports = [
	{
		"path": "php-scripts",
		"name": "PHP Scripts"
	},
	{
		"path": "wordpress",
		"name": "WordPress"
	},
	{
		"path": "javascript",
		"name": "JavaScript"
	},
	{
		"path": "css",
		"name": "CSS"
	},
	{
		"path": "mobile",
		"name": "Mobile"
	},
	{
		"path": "html5",
		"name": "HTML5"
	},
	{
		"path": "skins",
		"name": "Skins"
	},
	{
		"path": "plugins",
		"name": "Plugins"
	},
	{
		"path": "net",
		"name": ".NET"
	},
	{
		"path": "apps",
		"name": "Apps"
	},
	{
		"path": "edge-animate-templates",
		"name": "Edge Animate Templates"
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/categories/codecanyon.json
// module id = 220
// module chunks = 1 2